/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSON, FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSON, } from './FxIdDomainEntitiesDocumentsDocumentContentContentType';
/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsDocumentContent interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsDocumentContent(value) {
    if (!('Value' in value) || value['Value'] === undefined)
        return false;
    if (!('ContentType' in value) || value['ContentType'] === undefined)
        return false;
    return true;
}
export function FxIdDomainEntitiesDocumentsDocumentContentFromJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Value': json['Value'],
        'ContentType': FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSON(json['ContentType']),
    };
}
export function FxIdDomainEntitiesDocumentsDocumentContentToJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentContentToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentContentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Value': value['Value'],
        'ContentType': FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSON(value['ContentType']),
    };
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsDocumentContent.js.map